<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h3 class="page-title">Scan Report</h3>
	    </div>
    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-4 mt-4">
                        <div class="col-sm-3 mt-2"><input class="form-control" [(ngModel)]="search"  type="text" placeholder="Search" /></div>
                        <div class="col-sm-7 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Filter By Scan Done Date</mat-label>
                                <mat-date-range-input [max]="maxDate" [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                            <button type="button" class="btn btn-primary ml-4 mb-4" [disabled]="loading" (click)="getTotalScanReport(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Scan Data</button>
                            <button type="button" class="btn btn-primary ml-2 mb-4" [disabled]="loading" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                            <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="loading" (click)="exportScanReportList()"  data-toggle="tooltip" data-placement="top" title="Export Scan Report"><i class="fa fa-file-excel"></i></button>
                        </div>
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="getTotalScanReport(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
                </div>
                <div class="col-sm-6 p-3">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Circle</th>
                            <th>Scan Done Date</th>
                            <th>Month-Year</th>
                            <th>Patient Name</th>
                            <th>Glamyo Patient ID</th>
                            <th>Patient Contact Number</th>
                            <th>Email ID</th>
                            <th>Gender</th>
                            <th>Address</th>
                            <th>Appointment Time</th>
                            <th>BD Name</th>
                            <th>Scan pro</th>
                            <th>App Type</th>
                            <th>Scan Status</th>
                            <th>Document Link</th>
                            <th>Document upload date</th>
                            <th>Docs Share with Lab</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let scan_report of scanReportLists;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{scan_report.circle_name}}</td>
                            <td><span *ngIf="scan_report.scan_done_date">{{scan_report.scan_done_date*1000|date:'d MMM, yyyy'}}</span></td>
                            <td><span *ngIf="scan_report.scan_done_date">{{scan_report.scan_done_date*1000|date:'MMM-yyyy'}}</span></td>
                            <td>{{scan_report.lead_name}}</td>
                            <td>{{scan_report.glamyo_patient_id}}</td>
                            <td>{{scan_report.mobile}}</td>
                            <td>{{scan_report.email}}</td>
                            <td>{{scan_report.gender}}</td>
                            <td>{{scan_report.address}}</td>
                            <td><span *ngIf="scan_report.appointment_datetime">{{scan_report.appointment_datetime*1000|date:'d MMM, yyyy hh:mm aa'}}</span></td>
                            <td>{{scan_report.bd_name}}</td>
                            <td>{{scan_report.pro_name}}</td>
                            <td><span *ngIf="scan_report.appointment_type==1">New Scan</span><span *ngIf="scan_report.appointment_type==2">Re Scan</span></td>
                            <td><span *ngIf="scan_report.scan_status==1">Yes</span><span *ngIf="scan_report.scan_status==2">No</span></td>
                            <td>{{scan_report.google_form_link}}</td>
                            <td><span *ngIf="scan_report.document_upload_date">{{scan_report.document_upload_date*1000|date:'d MMM, yyyy'}}</span></td>
                            <td><span *ngIf="scan_report.link_send_on">{{scan_report.link_send_on*1000|date:'d MMM, yyyy  hh:mm aa'}}</span></td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="19" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !scanReportLists.length">
                            <td colspan="19" class="text-center"><i class="far fa-frown"></i> Sorry! No Plan Sent Found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>
